export default (theme) => ({
    variables: {
        marginTop: 40,
    },
    variable_row: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 20,

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            marginTop: 40,
        }
    },
    variable_row_info: {
        flex: '1 1 30%',
        display: 'flex',
        flexDirection: 'column',
        paddingRight: 8,

        '& .MuiTypography-root.MuiTypography-caption': {
            color: '#9e9e9e',
            marginTop: 8,
        },

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'row',
            alignItems: 'center',
            paddingRight: 0,
            width: '100%',
            marginBottom: 20,

            '& .MuiTypography-root.MuiTypography-body2': {
                flex: '1 1 50%'
            },

            '& .MuiTypography-root.MuiTypography-caption': {
                flex: '1 1 50%',
                marginTop: 0,
                fontSize: '0.875rem'
            },
        }
    },
    variable_row_input: {
        flex: '1 1 70%',
        paddingLeft: 12,

        [theme.breakpoints.down('xs')]: {
            paddingLeft: 0,
            width: '100%',
            // flex: '1 1 100%',
        }
    },
});
